import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import instance from "../../Utils/api";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));


const Employeestatus = ({ setstatusDialog, statusDialog, selectedEmployee, setEmployees }) => {
    const handleClose = () => {
        setstatusDialog(false);
    }

    //handleEmployeeStatus
    const handleEmployeeStatus = async () => {
        try {
            const response = await instance.patch(`/Admin/ToggleStatus?author_id=${selectedEmployee.employeeId}`,)
            if (response.data.success === true) {
                toast.success(response?.data?.message)
                handleClose();
                setEmployees(true)
            } else {
                toast.error(response?.data?.message)
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message); // Handle errors
        }
    }

    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={statusDialog}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Change Employee Status
                </DialogTitle>
                <hr style={{ margin: 10 }} />
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Typography>
                        Are you sure you want to change the status of employee <strong>{selectedEmployee?.employeeName || "Unnamed Employee"}</strong>? This action will affect their access and responsibilities.
                    </Typography>
                </DialogContent>
                <DialogActions >
                    <Button className="cancel-btn" onClick={handleClose}>No, Keep Current Status</Button>
                    <Button className="add-btn" onClick={handleEmployeeStatus}>Yes, Update Status</Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default Employeestatus;